// extracted by mini-css-extract-plugin
export default {"replacements":"EditableText_replacements__9R4k9"};